import { ReactComponent as EditIcon } from "assets/images/icons/btn_edit.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin.svg";
import { ReactComponent as RemoveHoverIcon } from "assets/images/icons/icn_btn_bin_hover.svg";

import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Tooltip, Typography } from "@mui/material";

const ActionIcons = ({
  rowData,
  editUserAccountProfile,
  deleteUserAccountProfile,
  showEditGeneral,
}) => {
  const [isRemoveHovered, setIsRemoveHovered] = useState(false);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <EditIcon
        onClick={() => editUserAccountProfile(rowData)}
        style={{ cursor: "pointer", margin: "0 6px 0 2px", width: "18px", height: "18px" }}
      />
      {showEditGeneral && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "primary.greyThread",
              height: "20px",
              width: "1px",
              margin: "0 10px",
            }}
          />
          <Box
            onMouseEnter={() => setIsRemoveHovered(true)}
            onMouseLeave={() => setIsRemoveHovered(false)}
            onClick={() => deleteUserAccountProfile(rowData)}
            sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {isRemoveHovered ? (
              <RemoveHoverIcon style={{ width: "20px", height: "20px", margin: "0 6px 0 2px" }} />
            ) : (
              <RemoveIcon style={{ width: "20px", height: "20px", margin: "0 6px 0 2px" }} />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

const EllipsisTooltipCell = ({ text }) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={isOverflow ? <Typography sx={{ whiteSpace: "normal" }}>{text || "-"}</Typography> : ""}
      disableHoverListener={!isOverflow}
      arrow
    >
      <Box
        ref={textRef}
        sx={{
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text || "-"}
      </Box>
    </Tooltip>
  );
};

export const getTableColumns = (
  theme,
  columnHelper,
  showEditGeneral,
  editUserAccountProfile,
  deleteUserAccountProfile
) => [
  columnHelper.accessor("profileName", {
    header: "Profile Name",
    meta: {},
    cell: info => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <EllipsisTooltipCell text={info.getValue()} />
      </Box>
    ),
  }),
  columnHelper.accessor("accounts", {
    header: "Accounts",
    meta: {},
    cell: info => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {info.getValue()}
      </Box>
    ),
  }),
  columnHelper.display({
    id: "action",
    header: "Actions",
    meta: { isAction: true },
    cell: info => {
      const rowData = info.row.original;

      return (
        <ActionIcons
          rowData={rowData}
          editUserAccountProfile={editUserAccountProfile}
          deleteUserAccountProfile={deleteUserAccountProfile}
          showEditGeneral={showEditGeneral}
        />
      );
    },
  }),
].filter(Boolean);

export const fromJSON = (data) => {
  const rawAccountList = data.accountList || [];
  const userAccountList = rawAccountList.map((item) => ({
    username: item.userName,
    password: item.password,
    description: item.description,
  }));

  return {
    id: data.id,
    profileName: data.name,
    accounts: userAccountList.length,
    ref: {
      ...data,
      userAccountList,
    },
  };
};

export const toJSON = (data, id = null) => {
  const payload = {
    name: data.name,
    accountList: (data.userAccounts || []).map((item) => ({
      userName: item.username,
      password: item.password,
      description: item.description || null,
    })),
  };

  if (id) {
    return {
      id,
      ...payload,
    };
  }

  return payload;
};
